<schedule-detail-header [title]="streetAddress"
                        [subtitle]="subtitle"
                        [backCallback]="goBack.bind(this)"
                        [showCloud]="true">
</schedule-detail-header>

<p-tabs [value]="activeTab"
        (valueChange)="onTabChange($event.toString())"
        class="tab-container"
        data-testid="view-report-tabs">
  <p-tablist [class.faded]="!dataLoaded">
    <p-tab value="0" data-testid="view-report-tab-looks-good">Looks Good</p-tab>
    <p-tab value="1" data-testid="view-report-tab-needs-attention">Needs Attention</p-tab>
  </p-tablist>

  <p-tabpanels>
    @if (dataLoaded) {
      <!-- LOOKS GOOD [style.display]="'flex'" [style.height]="'100%'" -->
      <p-tabpanel value="0">

        @if (looksGoodGroupedByArea().length === 0) {
          <div class="empty-state" data-testid="view-report-container-no-looks-good">
            <img class="icon"
                 src="assets/icons/fact-check-outline.svg"
                 alt="All clear!" />
            <div class="title">Nothing to review here.</div>
            <div class="subtitle">{{'No notes or images were \n added to completed items.'}}</div>
          </div>
        }
        @else {
          <div class="area-card"
               *ngFor="let group of looksGoodGroupedByArea(); trackBy: trackByAreaKey"
               data-testid="view-report-list-looks-good">
            <div class="component-card"
                 *ngFor="let a of group.assertions; trackBy: trackByAssertion"
                 (click)="navigateToAssertion(a)"
                 role="button"
                 tabindex="0"
                 (keyup.enter)="navigateToAssertion(a)"
                 data-testid="view-report-item-looks-good">
              <card-report-item [item]="a"
                                [isNeedsAttentionCard]="false" />
            </div>
          </div>
          <div class="report-hint" data-testid="view-report-text-hint">
            Only items with an image or a note appear in the final report.
          </div>
        }
      </p-tabpanel>

      <!-- NEEDS ATTENTION -->
      <p-tabpanel value="1">
        @if (allIssues.length === 0) {
          <div class="empty-state" data-testid="view-report-container-no-issues">
            <img class="icon"
                 src="assets/icons/home-mode-outline-rounded.svg"
                 alt="Looking great!" />
            <div class="title">No issues logged - looking great!</div>
            <div class="subtitle">{{ 'Next, review completed items\n with photos or notes.' }}</div>
          </div>
        }
        @else {
          <div class="totals-card"
               *ngIf="allIssues.length > 0"
               data-testid="view-report-chart-issues">
            <div class="severity-header">Total Issues</div>
            <app-issues-chart [minor]="minorCount"
                              [major]="majorCount"
                              [missing]="missingCount">
            </app-issues-chart>
          </div>


          <!-- MINOR ISSUES -->
          <div class="severity-header-card"
               *ngIf="issuesBySeverity()?.minor?.length"
               data-testid="view-report-text-minor-title">Minor</div>
          <div class="area-card"
               *ngIf="issuesBySeverity()?.minor?.length"
               data-testid="view-report-list-minor">
            <div class="component-card"
                 *ngFor="let issue of issuesBySeverity().minor; trackBy: trackByIssue"
                 (click)="navigateToIssue(issue)"
                 role="button"
                 tabindex="0"
                 (keyup.enter)="navigateToIssue(issue)"
                 data-testid="view-report-item-minor">
              <card-report-item [item]="issue"
                                [isNeedsAttentionCard]="true" />
            </div>
          </div>

          <!-- MAJOR ISSUES -->
          <div class="severity-header-card"
               [style.marginTop.px]="24"
               *ngIf="issuesBySeverity()?.major?.length"
               data-testid="view-report-text-major-title">Major</div>
          <div class="area-card"
               *ngIf="issuesBySeverity()?.major?.length"
               data-testid="view-report-list-major">
            <div class="component-card"
                 *ngFor="let issue of issuesBySeverity().major; trackBy: trackByIssue"
                 (click)="navigateToIssue(issue)"
                 role="button"
                 tabindex="0"
                 (keyup.enter)="navigateToIssue(issue)"
                 data-testid="view-report-item-major">
              <card-report-item [item]="issue"
                                [isNeedsAttentionCard]="true" />
            </div>
          </div>

          <!-- MISSING ISSUES -->
          <div class="severity-header-card"
               [style.marginTop.px]="24"
               *ngIf="issuesBySeverity()?.missing?.length"
               data-testid="view-report-text-missing-title">Missing</div>
          <div class="area-card"
               *ngIf="issuesBySeverity()?.missing?.length"
               data-testid="view-report-list-missing">
            <div class="component-card"
                 *ngFor="let issue of issuesBySeverity().missing; trackBy: trackByIssue"
                 (click)="navigateToIssue(issue)"
                 role="button"
                 tabindex="0"
                 (keyup.enter)="navigateToIssue(issue)"
                 data-testid="view-report-item-missing">

              <card-report-item [item]="issue"
                                [isNeedsAttentionCard]="true" />
            </div>
          </div>
        }
      </p-tabpanel>
    } @else {
      <p-tabpanel value="0">
        <div class="view-report-skeleton" data-testid="view-report-skeleton-looks-good">
          <p-skeleton height="4.5rem"></p-skeleton>
          <p-skeleton height="4.5rem"></p-skeleton>
          <p-skeleton height="4.5rem"></p-skeleton>
          <p-skeleton height="4.5rem"></p-skeleton>
        </div>

      </p-tabpanel>
      <p-tabpanel value="1">
        <div class="view-report-skeleton" data-testid="view-report-skeleton-needs-attention">
          <p-skeleton height="11.5rem"></p-skeleton>
          <p-skeleton height="4.5rem"></p-skeleton>
          <p-skeleton height="4.5rem"></p-skeleton>
          <p-skeleton height="4.5rem"></p-skeleton>
          <p-skeleton height="4.5rem"></p-skeleton>
        </div>

      </p-tabpanel>
    }
  </p-tabpanels>
</p-tabs>
